import {useJsonFetch} from '@sail/data';
import type {FetchState} from '@sail/data';

import type {ResumeFundingSessionResponse} from 'src/fund/state/types';
import {getCryptoStandaloneUrl} from 'src/utils/buildStripeApiClient';

export const useResumeFundingSession = (
  sessionHash: string,
): FetchState<ResumeFundingSessionResponse> => {
  return useJsonFetch<ResumeFundingSessionResponse>(
    getCryptoStandaloneUrl('/resume_funding_session'),
    {
      method: 'POST',
      body: new URLSearchParams({
        session_hash: sessionHash,
        referrer: window.location.hostname,
      }).toString(),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest',
      },
      expectedErrors: [400, 404, 410],
    },
  );
};
